const Api = {
     // 子账号管理
    '/api/team-manage/user-create': 1, // 创建子账号
    '/api/relay/relay-anchor': 1, // 交接给达人
    '/api/team-manage/user-update': 1, // 账号编辑
    '/api/relay/relay-institution': 1, //交接给团长
    '/api/relay/relay-product': 1, // 交接店铺
    '/api/account/disable': 1, //停用
    '/api/partner-rate/set-rate': 1, // 商务提成比
    '/api/partner-rate/set-merchants-rate': 1,//招商提成比
    // 部门管理
    '/api/team-manage/create': 1, // 新增部门
    '/api/team-manage/delete': 1, // 删除部门
    //角色管理
    '/api/team-manage/role-add-user': 1, //新增角色
    '/api/team-manage/role-del': 1, //删除角色
    '/api/team-manage/role-save': 1 // 新增角色
}

export default {
  Api
};